<div><svg class="inline-block align-middle" v-if="svgContent" :style="svgStyle" viewBox="0 0 24 24" v-html="svgContent"></svg><slot></slot></div>